(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["start-today-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const prepareMenus = (scope = document) => {
      const roots = scope.matches?.('[data-st-root]')
        ? [scope]
        : scope.querySelectorAll('[data-st-root]');

      roots.forEach((root) => {
        root.querySelectorAll('.st-menu:not([data-st-menu-ready])').forEach((menu) => {
          menu.setAttribute('data-st-menu-ready', '');

          menu.addEventListener('click', (event) => {
            const link = event.target.closest?.('a');
            if (!link) return;
            menu.removeAttribute('open');
          });
        });
      });
    };

    const prepareReveals = (scope = document) => {
      const roots = scope.matches?.('[data-st-root]')
        ? [scope]
        : scope.querySelectorAll('[data-st-root]');

      roots.forEach((root) => {
        const reveals = root.querySelectorAll('[data-st-reveal]:not(.is-revealed)');

        if (reducedMotion.matches || !('IntersectionObserver' in window)) {
          reveals.forEach((element) => element.classList.add('is-revealed'));
          return;
        }

        root.classList.add('st-motion-ready');

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        }, {
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.12
        });

        reveals.forEach((element) => observer.observe(element));
      });
    };

    const initialize = (scope = document) => {
      prepareMenus(scope);
      prepareReveals(scope);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
